/* oxlint-disable react/no-danger */
import * as React from 'react';
import * as styles from './Description.css';
import DOMPurify from 'isomorphic-dompurify';

interface IDescriptionProps {
  description: string;
}

export function Description({ description }: IDescriptionProps) {
  const purifiedDescription = React.useMemo(() => {
    if (!description) {
      return '';
    }

    return DOMPurify.sanitize(description.replace(/<h3.*?<\/h3>/gm, ''));
  }, [description]);

  if (!description) {
    return null;
  }

  return (
    <div
      className={styles['container']}
      data-testid="description"
      dangerouslySetInnerHTML={{ __html: purifiedDescription }}
    />
  );
}
